import createAxiosInstance from './createAxiosInstance'

const path = process.env.VUE_APP_HOUSEKEEPER_API
const instance = createAxiosInstance(`${path}/api/v1`)

export const apiDisasterForecasts = {
  /**
  * 取得災害警報
  * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/DisasterForecast/get_api_v1_DisasterForecast_forecast
  */
  getDisasterAlert: () => instance.get('/DisasterForecast/warnings'),
  /**
  * 取得特定災害詳情
  * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/DisasterForecast/get_api_v1_DisasterForecast_warnings
  */
  getDisasterDetail: (type) => instance.get(`/DisasterForecast/forecast?type=${type}`)
}
